module.exports = __webpack_public_path__ + "img/logofoot.08aba0be.png";